/// <amd-module name="Repos/Views/Import/Components/Clone/CloneNotice" />
import * as React from "react";

import { Icon } from "VSSUI/Icon";
import { Link } from "VSSUI/Link";

import { FormatComponent } from "VSS/Platform/Components/Format/Format";

import * as Resources from "Repos/Views/Import/Resources";

export function CloneNotice() {
    return (
        <div className="flex-row flex-center margin-bottom-4 body-s">
            <Icon className="icon-margin" iconName="Info" />
            <div className="secondary-text">
                <FormatComponent format={Resources.HavingProblems}>
                    <Link className="white-space-nowrap" href="https://go.microsoft.com/fwlink/?LinkID=278817&clcid=0x409" target="_blank">
                        Git for Windows
                    </Link>
                    <Link className="white-space-nowrap" href="https://go.microsoft.com/fwlink/?LinkID=723021" target="_blank">
                        IntelliJ
                    </Link>
                    <Link className="white-space-nowrap" href="https://go.microsoft.com/fwlink/?LinkID=723023" target="_blank">
                        Eclipse
                    </Link>
                    <Link className="white-space-nowrap" href="https://go.microsoft.com/fwlink/?LinkId=723132" target="_blank">
                        Android Studio
                    </Link>
                    <Link className="white-space-nowrap" href="https://go.microsoft.com/fwlink/?LinkID=723024" target="_blank">
                        Windows command line
                    </Link>
                </FormatComponent>
            </div>
        </div>
    );
}
